// @flow strict

import { Button, Input, Space, Table, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { FiSearch } from "react-icons/fi";
import { getSubscriberList } from '../../../api/pricing';
import SingleSubscriber from './SingleSubscriber';

function Subscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };

  async function fetchSubscriberData() {
    setLoading(true);

    try {
      const response = await getSubscriberList();
      if (response?.data?.subscribers) {
        setSubscribers(response.data.subscribers);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div className="p-4 d-flex flex-column gap-3" onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
        />
        <Space>
          <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} icon={<FiSearch />}>
            Search
          </Button>
          <Button danger onClick={() => clearFilters && handleReset(clearFilters, confirm)}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <FiSearch style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) => text,
  });

  const columns = [
    {
      title: <p className="text-center my-0">Company</p>,
      dataIndex: 'companyName',
      key: 'companyName',
      render: (company) => <p className="my-0">{company}</p>,
      ...getColumnSearchProps('companyName', 'company'),
    },
    {
      title: <p className="text-center my-0">Email</p>,
      dataIndex: 'orgEmail',
      key: 'orgEmail',
      ...getColumnSearchProps('orgEmail', 'email'),
    },
    {
      title: <p className="text-center my-0">Plan</p>,
      key: 'plan',
      dataIndex: 'plan',
      render: (plan) => <Tag color="cyan">{plan.name}</Tag>,
    },
    {
      title: <p className="text-center my-0">Status</p>,
      key: 'status',
      dataIndex: 'status',
      render: (status) => (
        status === "active" ? <Tag color="success">{status}</Tag> : <span>{status}</span>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: <p className="text-center my-0">Actions</p>,
      render: (_, subscriber) => <SingleSubscriber subscriber={subscriber} />,
    },
  ];

  useEffect(() => {
    fetchSubscriberData();
  }, []);

  return (
    <div className="container px-3 px-md-5 py-4 overflow-auto">
      <h5 className="mb-3">Subscribed Organization List</h5>
      <Table
        bordered
        responsive
        dataSource={subscribers}
        columns={columns}
        scroll={{ x: true }}
        tableLayout="auto"
        pagination={{ position: ["bottomCenter"] }}
        loading={loading}
        className="shadow-sm rounded"
      />
    </div>
  );
}

export default Subscribers;
